import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem('yamass_cart')) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('yamass_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, size, quantity = 1) => {
    setCart(prev => {
      const existing = prev.find(i => i._id === product._id && i.size === size);
      if (existing) {
        return prev.map(i =>
          i._id === product._id && i.size === size
            ? { ...i, quantity: i.quantity + quantity }
            : i
        );
      }
      return [...prev, { ...product, size, quantity }];
    });
  };

  const removeFromCart = (productId, size) => {
    setCart(prev => prev.filter(i => !(i._id === productId && i.size === size)));
  };

  const updateQuantity = (productId, size, quantity) => {
    if (quantity < 1) return removeFromCart(productId, size);
    setCart(prev =>
      prev.map(i => i._id === productId && i.size === size ? { ...i, quantity } : i)
    );
  };

  const clearCart = () => setCart([]);

  const cartTotal   = cart.reduce((sum, i) => sum + (i.salePrice || i.price) * i.quantity, 0);
  const cartCount   = cart.reduce((sum, i) => sum + i.quantity, 0);
  const shippingFee = cartTotal >= 1000 ? 0 : 80; // Free shipping over ৳1000

  return (
    <CartContext.Provider value={{
      cart, addToCart, removeFromCart, updateQuantity, clearCart,
      cartTotal, cartCount, shippingFee
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
